// Compact "free tool" promo for service/industry/practice pages.
// Renders the page's featured published tool (spec §4) or nothing.
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { featuredToolFor, toolsOwnedBy } from "@/data/tools/registry";
import { track } from "@/lib/analytics";

export default function ToolPromo({ pageUrl, testid = "tool-promo" }) {
  const tool = featuredToolFor(pageUrl);
  if (!tool) return null;
  const ownedCount = toolsOwnedBy(pageUrl).length;
  return (
    <section data-testid={testid} className="py-10 md:py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="border-2 border-black p-6 md:p-8 grid md:grid-cols-[1fr_auto] items-center gap-6">
          <div>
            <div className="overline">Free tool — try it before you call us</div>
            <Link
              to={tool.url}
              data-testid={`${testid}-link`}
              onClick={() => track("tool_card_click", { tool: tool.id, source: pageUrl })}
              className="group mt-3 flex w-fit items-baseline gap-2 font-serif-display text-2xl md:text-3xl text-black"
            >
              {tool.name}
              <ArrowUpRight className="h-5 w-5 self-center text-zinc-300 group-hover:text-black group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
            </Link>
            <p className="mt-2 text-sm text-zinc-600 leading-relaxed max-w-xl">{tool.hook}</p>
          </div>
          <div className="flex md:flex-col gap-3 md:text-right">
            <Link
              to={tool.url}
              data-testid={`${testid}-cta`}
              className="inline-flex items-center justify-center h-11 px-5 bg-black text-white text-sm font-medium hover:bg-zinc-800 transition-colors"
            >
              Use the Free Tool
            </Link>
            {ownedCount > 1 && (
              <Link to={`/tools`} data-testid={`${testid}-more`} className="text-xs text-zinc-500 underline underline-offset-4 hover:text-black self-center md:self-end">
                + {ownedCount - 1} more for this expertise
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
